export default "__VITE_PUBLIC_ASSET__2c875e27__"